import { PropertyTransactionsContainer } from 'components/modules/Properties/Details/Transactions';

export const PropertyTransactions = () => <PropertyTransactionsContainer />;
